import React, { useState, useEffect } from "react";
import { Container, Accordion, Card, useAccordionToggle } from "react-bootstrap";
import HTMLReactParser from 'html-react-parser';
import { Helmet } from "react-helmet"
import { useContext } from "react"
import { useLocation } from "@reach/router";
import { graphql, useStaticQuery } from "gatsby";
import AccordionContext from "react-bootstrap/AccordionContext"

const ResultsFaq = (props) => {

    const data = useStaticQuery(graphql`
    query {
        glstrapi {
            globalModule {
                Results_FAQ {
                    Slug
                    Show_FAQ_Schema
                    id
                    FAQ_List {
                        Title
                        Description
                    }
                }
            }
        }
      }
    `)
    const AccordionItems = data?.glstrapi?.globalModule?.Results_FAQ
    var {pathname} = useLocation();
    let AccordionItemsList = [];
    var faqschemaList = [];
    
   const normalize = (str) =>{
        if (!str) return '';
        // Remove any leading or trailing slashes
        const trimmed = str.replace(/^\/|\/$/g, '');
        // Add a single leading slash and force lowercase
        return '/' + trimmed.toLowerCase();
   }

    //generate faq items array list based on pathname

    const path = normalize(pathname);
    AccordionItems?.forEach(item => {
    if (path === normalize(item?.Slug)) {
        AccordionItemsList.push(item);
    }
    });

    let showfaq = AccordionItemsList[0]?.Show_FAQ_Schema;
   
   //generate faq schema array list
   showfaq && AccordionItemsList && AccordionItemsList[0]?.FAQ_List.map((faqitem,i) =>{
        faqschemaList.push({
            "@type": "Question",
            "name": `${faqitem?.Title}`,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `${faqitem?.Description}`
            }
        })
    })


    function CustomToggle({ children, eventKey, callback }) {
        const currentEventKey = useContext(AccordionContext);
        const decoratedOnClick = useAccordionToggle(eventKey, () =>
            eventKey,
            () => callback && callback(eventKey), 
        );
        const isCurrentEventKey = currentEventKey === eventKey;
        return (
            <div

                className="card-header"
                onClick={decoratedOnClick}
            >
                {children}
                <span><i className={isCurrentEventKey ? 'icon-show' : 'icon-plus'}> </i></span>
            </div>
        );
    }

    return (
         <>
       {showfaq &&
         <Helmet>
            <script type="application/ld+json">{`{
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": ${JSON.stringify(faqschemaList, null, 2)}
                }`}
           </script> 
        </Helmet>}
        <React.Fragment>
             { AccordionItemsList && AccordionItemsList[0]?.FAQ_List && AccordionItemsList[0]?.FAQ_List.length > 0 &&
            <section className="service-card sec-pdy-120 results-faq">
                <Container>
                    {props?.SectionTitle ? <h4>{props?.SectionTitle}</h4> : <h4>Frequently Asked Questions</h4>}
                    <Accordion defaultActiveKey="5">
                        { AccordionItemsList[0]?.FAQ_List && AccordionItemsList[0]?.FAQ_List.map((card, i) => {
                            return (
                                    <Card>
                                        <CustomToggle as={Card.Header} eventKey={i + 1} className="text-sm-bold"> <span className="text-sm-bold">{card.Title}</span>
                                        </CustomToggle>
        
                                        <Accordion.Collapse eventKey={i + 1}>
                                            <Card.Body className="text-sm">
                                                {HTMLReactParser(card.Description.replace(/\n/g, ''))}
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                )
                        })}
                    </Accordion>
                    
                    {/* <div className="d-flex justify-content-start mt-5">
                        <a href="/about-dacha/faqs/" className="btn btn-primary">
                           View More
                        </a>
                    </div> */}
                </Container>
            </section>}
        </React.Fragment>
        </>
    )
}
export default ResultsFaq